<template>
  <div id="park-card-detail" class="park-detail">
    <div class="park-detail-base">
      <div class="park-detail-base-img">
        <div :class="['swiper', 'mySwiper2', 'mySwiper2_' + landId]">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in landFileInfo.pronounceImages"
              :src="imgUrl + item.filePath"
              :key="index"
              @click="handleLook(landFileInfo.pronounceImages, index)"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
        </div>
        <div :class="['swiper', 'mySwiper', 'mySwiper_' + landId]">
          <div class="swiper-wrapper">
            <el-image
              v-for="(item, index) in landFileInfo.pronounceImages"
              :src="imgUrl + item.filePath"
              :key="index"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
          <div class="swiper-button-prev m-swiper-button" />
          <div class="swiper-button-next m-swiper-button" />
        </div>
      </div>
      <div class="park-detail-base-content">
        <div class="park-detail-base-content-price">
          <div class="park-detail-base-content-price-text">
            {{ landDetailData.name }}
          </div>
          <div class="park-detail-base-content-price-span">
            浏览：{{ landDetailData.statistical }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系人</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ landDetailData.person }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">联系方式</div>
          <div
            class="park-detail-base-content-info-value info-value-text1 info-value-bold"
          >
            {{ landDetailData.phone }}
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">出让年限</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ landDetailData.transferDate ?? "50" }}年
          </div>
        </div>
        <div class="park-detail-base-content-info">
          <div class="park-detail-base-content-info-key">用地面积</div>
          <div class="park-detail-base-content-info-value info-value-text2">
            {{ landDetailData.area }}亩
          </div>
        </div>
        <div class="park-detail-base-content-info grid-single-line">
          <div class="park-detail-base-content-info-key">土地坐落</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ landDetailData.location }}
          </div>
        </div>
      </div>
    </div>
    <div class="park-detail-info">
      <div class="park-detail-info-content">
        <div id="landInfo" class="park-detail-info-park">
          <div class="park-detail-info-sub-title">◇详细信息</div>
          <div class="park-detail-info-park-content">
            <table border="1" class="park-detail-table">
              <tr>
                <td colspan="4" class="park-detail-table-header">基本信息</td>
              </tr>
              <tr>
                <td class="park-detail-table-key">地块类型</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.statusName }}
                </td>
                <td class="park-detail-table-key">土地坐落</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.location }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">宗地编号</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.code }}
                </td>
                <td class="park-detail-table-key">土地等级</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.landLevelName }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">用地面积</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.area }}亩
                </td>
                <td class="park-detail-table-key">出让年限</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.transferDate }}年
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">用地状态</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.cleanLand == 1 ? "净地" : "非净地" }}
                </td>
                <td class="park-detail-table-key">行政区划</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.countyName }}
                </td>
              </tr>
              <tr>
                <td colspan="4" class="park-detail-table-header">规划条件</td>
              </tr>
              <tr>
                <td class="park-detail-table-key">容积率</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.plotRate }}
                </td>
                <td class="park-detail-table-key">绿化率</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.greeningRate }}％
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">建筑密度</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.buildingDensity }}％
                </td>
                <td class="park-detail-table-key">建筑限高</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.buildingHeight }}米
                </td>
              </tr>
              <tr>
                <td colspan="4" class="park-detail-table-header">
                  地块招商信息
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">项目名称</td>
                <td colspan="3" class="park-detail-table-value">
                  {{ landDetailData.name }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">土地用途</td>
                <td colspan="3" class="park-detail-table-value">
                  {{ landDetailData.typeName }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">行业分类</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.industryTypeName }}
                </td>
                <td class="park-detail-table-key">用地联系人</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.person }}
                </td>
              </tr>
              <tr>
                <td class="park-detail-table-key">参考价格</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.price }}万元
                </td>
                <td class="park-detail-table-key">联系方式</td>
                <td class="park-detail-table-value">
                  {{ landDetailData.phone }}
                </td>
              </tr>
            </table>
            <div
              v-if="landFileInfo.pronounceVideos?.length"
              class="park-detail-info-investment-video"
            >
              <div
                v-for="item of landFileInfo.pronounceVideos"
                class="park-detail-info-investment-video-item"
                @click="playVideos(item)"
              >
                <div class="park-detail-info-investment-video-item-thumbnail">
                  <el-image
                    :src="imgUrl + item.thumbnail"
                    fit="cover"
                    class="park-detail-info-investment-video-item-thumbnail-img"
                  />
                  <el-image
                    :src="require('@/assets/images/common/视频播放.png')"
                    fit="cover"
                    class="park-detail-info-investment-video-item-thumbnail-action"
                  />
                </div>
                <div class="park-detail-info-investment-video-item-title">
                  {{ item.fileTitle }}
                </div>
              </div>
            </div>
            <div
              v-if="landFileInfo.pronounceImages?.length"
              class="park-detail-info-investment-image"
            >
              <div
                v-for="(item, index) of landFileInfo.pronounceImages"
                :key="index"
                class="park-detail-info-investment-image-item"
                @click="handleLook(landFileInfo.pronounceImages, index)"
              >
                <el-image
                  :src="imgUrl + item.filePath"
                  fit="cover"
                  class="park-detail-info-investment-image-item-img"
                />
                <div class="park-detail-info-investment-image-item-title">
                  {{ item.fileTitle }}
                </div>
              </div>
            </div>
            <div
              v-if="landFileInfo.pronounceFiles?.length"
              class="park-detail-info-investment-file"
            >
              <div
                class="park-detail-info-investment-file-li"
                v-for="(item, index) of landFileInfo.pronounceFiles"
                :key="index"
                @click="previewOrDownFile(item.filePath)"
              >
                <div><img :src="getFileIconUrl(item.suffix)" alt="" /></div>
                <div class="park-detail-info-investment-image-item-title">
                  {{ item.fileTitle }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 10px">
          <land-place
            id="landPlace"
            :info="fileShp"
            :detail="{ name: landDetailData.name, id: landDetailData.id }"
            v-if="landDetailData.name"
          />
        </div>
      </div>

      <video-dialog
        :visible="playVideo.show"
        :videoSrc="playVideo.src"
        :videoTitle="playVideo.title"
        @onCloseVideo="playVideo.show = false"
      />
      <el-image-viewer
        v-if="previewImage.show"
        :url-list="previewImage.urlList"
        :initial-index="previewImage.index"
        :on-close="() => (previewImage.show = false)"
        style="z-index: 9999"
      />
    </div>
  </div>
</template>
  
  <script>
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.min.css";
import VideoDialog from "@/components/currency/videoDialog";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import LandPlace from "@/views/land/components/LandPlace";
import { getLandInfoTwo, getPicture, getShp } from "@/api/setting/investment";

/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/15 16:38
 * @Description 地块详情
 */
export default {
  name: "park-card-detail",
  components: { LandPlace, ElImageViewer, VideoDialog },
  props: {
    landId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      landDetailData: {},
      landFileInfo: {}, //文件信息
      fileShp: {}, //图形数据
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      playVideo: {
        show: false,
        src: undefined,
        title: undefined,
      },
      previewImage: {
        show: false,
        urlList: [],
        index: 0,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getDetail(this.landId);
      this.getPictureInfo(this.landId);
      this.getShpInfo(this.landId);
      this.setSwiper();
    });
  },
  methods: {
    getShpInfo(id) {
      getShp(id).then((res) => {
        if (res.data.success) {
          this.fileShp = res.data.data;
        }
      });
    },
    getPictureInfo(id) {
      getPicture(id).then((res) => {
        if (res.data.success) {
          this.landFileInfo = res.data.data;
        }
      });
    },
    getDetail(id) {
      getLandInfoTwo(id)
        .then((res) => {
          if (res.data.success) {
            this.landDetailData = res.data.data;
            // if (!this.landDetailData.pronouncePolygons) {
            //   this.$message.warning("没有提交shp数据");
            // }
          }
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    getFileIconUrl(fileSuffix) {
      let iconUrl;
      switch (fileSuffix) {
        case "pdf":
          iconUrl = require("@/assets/images/common/文件-pdf.png");
          break;
        case "doc":
        case "docx":
          iconUrl = require("@/assets/images/common/文件-word.png");
          break;
        case "zip":
        case "rar":
          iconUrl = require("@/assets/images/common/文件-压缩包.png");
          break;
        case "xls":
        case "xlsx":
          iconUrl = require("@/assets/images/common/excel.png");
          break;
        default:
          iconUrl = require("@/assets/images/common/文件-其它.jpg");
      }
      return iconUrl;
    },
    setSwiper() {
      let swiper = new Swiper(`.mySwiper_${this.landId}`, {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      let swiper2 = new Swiper(`.mySwiper2_${this.landId}`, {
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: swiper,
        },
      });
    },
    scrollView(selector) {
      document.querySelector(selector).scrollIntoView();
    },
    previewOrDownFile(url) {
      window.open(this.imgUrl + url);
    },
    //播放视频
    playVideos(file) {
      this.playVideo.show = true;
      this.playVideo.src =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.playVideo.title = file.fileTitle || "";
    },
    //查看图片
    handleLook(list, index) {
      this.previewImage.urlList = [];
      list.forEach((item) => {
        this.previewImage.urlList.push(this.imgUrl + item.filePath);
      });
      this.previewImage.index = index;
      this.previewImage.show = true;
    },
  },
};
</script>
  
  <style scoped>
.park-detail {
  width: 100%;
  padding: 10px 20px;
}

.detail-l {
  width: calc(100% - 4px);
}
.detail-r {
  width: 2px;
  border-right: 2px solid #717171;
}
.park-detail-title {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e0e0e0;
  padding: 4px 2px 4px 0;
}

.park-detail-title-text {
  font-size: 1rem;
  font-weight: 600;
  flex-grow: 1;
}

.park-detail-title-browse-count {
  font-size: 0.75rem;
  color: #8a8a8a;
  align-self: flex-end;
  flex-shrink: 0;
}

.park-detail-base {
  display: flex;
  column-gap: 20px;
}

.park-detail-base-img {
  width: 50%;
  height: 300px;
}

.park-detail-base-content {
  width: 50%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px 10px;
  font-size: 0.85rem;
}

.park-detail-base-content-price {
  grid-column: 1 / -1;
  padding: 8px 4px;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.park-detail-base-content-price-text {
  font-weight: bold;
  font-size: 1rem;
}
.park-detail-base-content-price-span {
  font-size: 0.75rem;
  color: #837a7a;
}

.park-detail-base-content-info {
}

.park-detail-base-content-info-key {
}

.park-detail-base-content-info-value {
}

.info-value-bold {
  font-weight: bold;
}

.info-value-text1 {
  color: #0064fd;
}

.info-value-text2 {
  color: #317dfc;
  font-size: 0.75rem;
}

.info-value-text3 {
  color: #717171;
}

.grid-single-line {
  grid-column: 1 / -1;
}

.park-detail-info {
  margin-top: 20px;
}

.park-detail-info-content-nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 2fr;
  background-color: #f4f4f4;
  padding: 2px;
  cursor: pointer;
}

.park-detail-info-content-nav-item {
}

.park-detail-info-investment-file-li {
  width: 120px;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
}

.park-detail-info-sub-title {
  margin-top: 20px;
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-content {
  width: 100%;
}

.park-detail-info-investment-content > div {
  border: solid 1px #e0e0e0;
}

.park-detail-info-investment-video {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-video-item-thumbnail {
  width: 120px;
  height: 80px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.park-detail-info-investment-video-item-thumbnail-img {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
}

.park-detail-info-investment-video-item-thumbnail-action {
  grid-column: 2 / 3;
  grid-row: 2 /3;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  color: white;
}

.park-detail-info-investment-video-item-title {
}

.park-detail-info-investment-image {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-image-item-img {
  width: 120px;
  height: 80px;
}

.park-detail-info-investment-image-item-title {
}

.park-detail-info-investment-file {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border: solid 1px #e5e5e5;
}

.park-detail-info-investment-file-item-img {
  width: 120px;
  height: 80px;
  padding: 8px 28px;
  box-sizing: border-box;
  filter: grayscale(1);
}

table {
  border: solid 1px #d0d0d0;
  border-spacing: 0;
  border-collapse: collapse;
}

.park-detail-table {
  width: 100%;
  text-align: center;
  margin: 10px 0;
}

.park-detail-table-header {
  background-color: #e6efff;
  color: #105ab5;
  font-weight: 600;
  font-size: 1rem;
  padding: 12px;
}

.park-detail-table-key {
  width: calc(100% / 6);
  padding: 8px;
  color: #000000;
}

.park-detail-table-value {
  color: #858585;
  width: calc(100% / 6 * 2);
  padding: 8px;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 1.12rem;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: calc(100% / 7 * 5);
  width: 100%;
}

.mySwiper {
  height: calc(100% / 7 * 2);
  box-sizing: border-box;
  padding: 5px 0;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-swiper-button {
  --swiper-navigation-size: 14px;
  color: white;
  background-color: #00000073;
  width: 20px;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
}
>>> .tz-toggle-layout__warp {
  z-index: 1000 !important;
}
</style>
  